import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Menu, Phone, Shield, UserRound, X } from 'lucide-react';
import BrandMark from './BrandMark';
import TextNowLink from './TextNowLink';
import { CONTACT } from '../data/siteData';
import { useAuth } from '../lib/AuthContext';

const links = [
  ['Services', '/services'],
  ['About', '/about'],
  ['Experiences', '/experiences'],
  ['Games', '/games'],
  ['Nespresso', '/jonnys-towing-x-nespresso'],
  ['Community', '/in-the-community'],
  ['Courses', '/portal'],
  ['Contact', '/contact'],
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const { user, isAdmin } = useAuth();
  const accountPath = user ? (isAdmin ? '/admin' : '/portal') : '/portal/login';

  return (
    <>
      <div className="service-strip">
        <span>Richmond &amp; Greater Vancouver</span>
        <TextNowLink>Text Now</TextNowLink>
        <a href={CONTACT.phoneHref} data-roka-cta="call_dispatch" data-roka-label="Call dispatch">{CONTACT.phoneDisplay}</a>
      </div>
      <header className="site-header">
        <BrandMark />
        <nav className="desktop-nav" aria-label="Primary navigation">
          {links.map(([label, to]) => (
            <NavLink key={to} to={to} className={({ isActive }) => (isActive ? 'active' : '')}>{label}</NavLink>
          ))}
          {isAdmin && <NavLink to="/admin" className={({ isActive }) => (isActive ? 'active' : '')}>Admin</NavLink>}
        </nav>
        <div className="header-actions">
          <Link className="icon-link" to={accountPath} aria-label={isAdmin ? 'Open administration' : user ? 'Open course portal' : 'Log in'}>
            {isAdmin ? <Shield size={20} /> : <UserRound size={20} />}
          </Link>
          <a className="button button--primary button--small" href={CONTACT.phoneHref} data-roka-cta="call_dispatch" data-roka-label="Call dispatch"><Phone size={18} /> Call Now</a>
          <button className="menu-button" type="button" onClick={() => setOpen(true)} aria-label="Open menu"><Menu /></button>
        </div>
      </header>
      {open && (
        <div className="mobile-drawer" role="dialog" aria-modal="true" aria-label="Navigation menu">
          <button className="drawer-close" type="button" onClick={() => setOpen(false)} aria-label="Close menu"><X /></button>
          <BrandMark />
          <nav>
            {links.map(([label, to]) => <NavLink key={to} to={to} onClick={() => setOpen(false)}>{label}</NavLink>)}
            {isAdmin && <NavLink to="/admin" onClick={() => setOpen(false)}>Administration</NavLink>}
            <NavLink to="/school-events" onClick={() => setOpen(false)}>School Events</NavLink>
            <NavLink to="/community/halloween" onClick={() => setOpen(false)}>🎃 Halloween Donations</NavLink>
            <NavLink to="/jonnys-in-your-neighborhood" onClick={() => setOpen(false)}>In Your Neighbourhood</NavLink>
            <NavLink to="/mental-health-awareness" onClick={() => setOpen(false)}>Mental Health Resource</NavLink>
          </nav>
          <a className="button button--primary" href={CONTACT.phoneHref} data-roka-cta="call_dispatch" data-roka-label="Call dispatch"><Phone size={18} /> {CONTACT.phoneDisplay}</a>
        </div>
      )}
    </>
  );
}
